import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";

const SaleOrgLayout = () => {
  const navList = useNav();
  let { saleOrgBottomNav, saleTopNav } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={saleOrgBottomNav} topTabs={saleTopNav} />
      <Outlet />
    </div>
  )
}

export default SaleOrgLayout;